import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { OpenZenDeskModule } from '@fantaz/shared/directives/open-zendesk';
import { SharedLayoutFooterModule } from '@fantaz/shared/layout/footer';
import {
  MainLayoutComponent,
  MainViewComponent,
} from '@fantaz/shared/layout/main-view';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { EmptyListModule } from '@fantaz/shared/ui/empty-list';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TournamentFeatureShellComponent } from './tournament-features-shell.component';
import { tournamentsShellRoutes } from './tournaments-shell.routes';

@NgModule({
  declarations: [TournamentFeatureShellComponent, PageNotFoundComponent],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    EmptyListModule,
    RouterModule.forChild(tournamentsShellRoutes),
    MaterialModule,
    MatTabsModule,
    OpenZenDeskModule,
    SharedLayoutFooterModule,
    MainViewComponent,
    MainLayoutComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
})
export class TournamentFeaturesShellModule {}
